<template>
  <div class="container">
    <div class="columns">
      <div class="column content">
        <h3 class="has-text-centered-mobile">
          Vendors List
        </h3>
        <div :class="{ 'hide-edges': hideEdges }">
          <v-server-table
            ref="allVendors"
            :columns="tableColumns"
            :options="tableOptions"
            @loaded="loaded"
          >
            <template slot="beforeTable">
              <label class="label">Search table:</label>
              <div class="field has-addons">
                <p class="control is-marginless">
                  <textbox
                    id="filter-by"
                    type="text"
                    placeholder="Search"
                    :value="query"
                    @input="updateQuery"
                  />
                </p>
                <p class="control is-marginless">
                  <dropdown
                    aria-label="Filter By Type"
                    :options="{ 'VendorName': 'By Name', 'EIN': 'By EIN' }"
                    :value="filterBy"
                    label="Search Type"
                    @input="updateFilterBy"
                  />
                  <!-- :default-option="'VendorName'" -->
                </p>
              </div>
              <p
                v-show="filterIsEIN"
                class="has-text-danger"
              >
                <small>Search By EIN uses the last 4 digits only</small>
              </p>
            </template>
            <template
              slot="name"
              slot-scope="props"
            >
              <router-link
                :to="`/vendor/${props.row.id}`"
                class=""
              >
                {{ props.row.name }}
              </router-link>
            </template>

            <template
              slot="address"
              slot-scope="props"
            >
              {{ `${props.row.address1} ${props.row.address2 || ''}` }}
            </template>

            <template
              slot="zip"
              slot-scope="props"
            >
              {{ formatZip(props.row.zip) }}
            </template>
          </v-server-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';

import {
  Dropdown,
} from '@phila/phila-ui';

import { ServerTable } from 'vue-tables-2';
import { debounce } from 'lodash';

import { options }  from '@/config/tableOptions';
const tableColumns = [
  "name",
  "ein",
  "address",
  "city",
  "state",
  "zip",
];

Vue.use(
  ServerTable,
  {},
  false,
  'bulma'
);

export default {
  name: 'Vendors',
  components: {
    Dropdown,
  },
  data() {
    return {
      filterIsEIN: false,
      totalCount: false,
      loading: false,
      query: '',
      filterBy: 'VendorName',
      tableColumns,
      tableOptions: options({
        requestFunction: this.customRequestFunction,
        responseAdapter: this.customResponseAdapter,
        headings: {
          ein: "EIN",
          actions: "",
        },
        sortable: [ 'name' ],
        filterable: [],
        resizableColumns: true,
      }),
    };
  },
  computed: {
    hideEdges() {
      return (Math.ceil(this.totalCount / this.tableOptions.perPage) <
        this.tableOptions.pagination.chunk);
    },
  },
  methods: {
    loaded (data) {
      this.totalCount = data.totalCount;
    },
    async customRequestFunction(params) {
      const query = { ...params, ...{ query: this.query, filterBy: this.filterBy }};
      try {
        console.log('customRequestFunction params:', params);
        const { data } = await this.$store.dispatch('vendors/getVendors', query);
        console.log('customRequestFunction data:', data);
        return data;
      } catch (err) {
        return [];
      }
    },

    customResponseAdapter(data) {
      const resp = { data: [], count: 0 };
      if (typeof data === "object"
          && typeof data.vendorListResults === "object") {
        resp.data = data.vendorListResults;
        resp.count = data.totalCount;
      }

      return resp;
    },

    updateQuery: debounce(function(value) {
      this.query = value;
      this.$refs.allVendors.refresh();
    }, 500),

    updateFilterBy (value) {
      if (value === 'EIN') {
        this.filterIsEIN = true;
      } else {
        this.filterIsEIN = false;
      }

      this.filterBy = value;
      this.$refs.allVendors.refresh();
    },

    formatZip(zip) {
      let fullZip = '';
      if (zip != null && zip != undefined) {
        fullZip = String(zip).slice(0, 5);
        if (String(zip).length > 5) {
          let lastFour = String(zip).slice(5, 9);
          fullZip += `-${lastFour}`;
        }
      }
      return fullZip;
    },
  },
  // async fetch({ store }) {
  //   await store.dispatch('vendors/getAllVendors');
  // },
};
</script>

<style lang="scss">

.input-dropdown {
  select {
    padding-right: 3rem !important;
  }
}

.is-current {
  .is-current {
    background-color: $ben-franklin-blue-light;
    // background-color: #25cef7;
  }
}

</style>
